export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/localdev/repos/cr-quiz/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/home/localdev/repos/cr-quiz/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: '',
        name: '/admin/',
        component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/index.vue'),
        /* no children */
      },
      {
        path: 'dashboard',
        /* internal name: '/admin/dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/dashboard/',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/dashboard/index.vue'),
            /* no children */
          },
          {
            path: 'create',
            name: '/admin/dashboard/create',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/dashboard/create.vue'),
            /* no children */
          },
          {
            path: 'edit',
            /* internal name: '/admin/dashboard/edit' */
            /* no component */
            children: [
              {
                path: ':questionnaireId',
                name: '/admin/dashboard/edit/[questionnaireId]',
                component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/dashboard/edit/[questionnaireId].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'setting',
        /* internal name: '/admin/setting' */
        /* no component */
        children: [
          {
            path: '',
            name: '/admin/setting/',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/setting/index.vue'),
            /* no children */
          },
          {
            path: 'create',
            name: '/admin/setting/create',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/setting/create.vue'),
            /* no children */
          },
          {
            path: 'edit',
            name: '/admin/setting/edit',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/admin/setting/edit.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/cookies',
    name: '/cookies',
    component: () => import('/home/localdev/repos/cr-quiz/src/pages/cookies.vue'),
    /* no children */
  },
  {
    path: '/session',
    /* internal name: '/session' */
    /* no component */
    children: [
      {
        path: ':pinCode',
        /* internal name: '/session/[pinCode]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/session/[pinCode]/',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/index.vue'),
            /* no children */
          },
          {
            path: 'hunt',
            name: '/session/[pinCode]/hunt',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/hunt.vue'),
            /* no children */
          },
          {
            path: 'present',
            name: '/session/[pinCode]/present',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/present.vue'),
            /* no children */
          },
          {
            path: 'register',
            name: '/session/[pinCode]/register',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/register.vue'),
            /* no children */
          },
          {
            path: 'statistics',
            /* internal name: '/session/[pinCode]/statistics' */
            /* no component */
            children: [
              {
                path: '',
                name: '/session/[pinCode]/statistics/',
                component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/statistics/index.vue'),
                /* no children */
              },
              {
                path: 'player',
                /* internal name: '/session/[pinCode]/statistics/player' */
                /* no component */
                children: [
                  {
                    path: ':playerId',
                    name: '/session/[pinCode]/statistics/player/[playerId]',
                    component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/statistics/player/[playerId].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'players',
                /* internal name: '/session/[pinCode]/statistics/players' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/session/[pinCode]/statistics/players/',
                    component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/statistics/players/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'treasure',
            name: '/session/[pinCode]/treasure',
            component: () => import('/home/localdev/repos/cr-quiz/src/pages/session/[pinCode]/treasure.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

